export const Countries = [
    {
        label: {
            english: 'Afghanistan',
            french: 'Afghanistan',
            german: 'Afghanistan',
            dutch: 'Afghanistan',
        },
        code: '+93',
        emoji: '🇦🇫',
        value: 'AF',
    },
    {
        label: {
            english: 'Aland Islands',
            french: 'Îles Åland',
            german: 'Åland',
            dutch: 'Åland',
        },
        code: '+358',
        emoji: '🇦🇽',
        value: 'AX',
    },
    {
        label: {
            english: 'Albania',
            french: 'Albanie',
            german: 'Albanien',
            dutch: 'Albanië',
        },
        code: '+355',
        emoji: '🇦🇱',
        value: 'AL',
    },
    {
        label: {
            english: 'Algeria',
            french: 'Algérie',
            german: 'Algerien',
            dutch: 'Algerije',
        },
        code: '+213',
        emoji: '🇩🇿',
        value: 'DZ',
    },
    {
        label: {
            english: 'AmericanSamoa',
            french: 'Samoa américaines',
            german: 'Amerikanisch-Samoa',
            dutch: 'Amerikaans Samoa',
        },
        code: '+1684',
        emoji: '🇦🇸',
        value: 'AS',
    },
    {
        label: {
            english: 'Andorra',
            french: 'Andorre',
            german: 'Andorra',
            dutch: 'Andorra',
        },
        code: '+376',
        emoji: '🇦🇩',
        value: 'AD',
    },
    {
        label: {
            english: 'Angola',
            french: 'Angola',
            german: 'Angola',
            dutch: 'Angola',
        },
        code: '+244',
        emoji: '🇦🇴',
        value: 'AO',
    },
    {
        label: {
            english: 'Anguilla',
            french: 'Anguilla',
            german: 'Anguilla',
            dutch: 'Anguilla',
        },
        code: '+1264',
        emoji: '🇦🇮',
        value: 'AI',
    },
    {
        label: {
            english: 'Antarctica',
            french: 'Antarctique',
            german: 'Antarktis',
            dutch: 'Antarktis',
        },
        code: '+672',
        emoji: '🇦🇶',
        value: 'AQ',
    },
    {
        label: {
            english: 'Antigua and Barbuda',
            french: 'Antigua-et-Barbuda',
            german: 'Antigua und Barbuda',
            dutch: 'Antigua en Barbuda',
        },
        code: '+1268',
        emoji: '🇦🇬',
        value: 'AG',
    },
    {
        label: {
            english: 'Argentina',
            french: 'Argentine',
            german: 'Argentinien',
            dutch: 'Argentinië',
        },
        code: '+54',
        emoji: '🇦🇷',
        value: 'AR',
    },
    {
        label: {
            english: 'Armenia',
            french: 'Arménie',
            german: 'Armenien',
            dutch: 'Armenië',
        },
        code: '+374',
        emoji: '🇦🇲',
        value: 'AM',
    },
    {
        label: {
            english: 'Aruba',
            french: 'Aruba',
            german: 'Aruba',
            dutch: 'Aruba',
        },
        code: '+297',
        emoji: '🇦🇼',
        value: 'AW',
    },
    {
        label: {
            english: 'Australia',
            french: 'Australie',
            german: 'Australien',
            dutch: 'Australië',
        },
        code: '+61',
        emoji: '🇦🇺',
        value: 'AU',
    },
    {
        label: {
            english: 'Austria',
            french: 'Autriche',
            german: 'Österreich',
            dutch: 'Oostenrijk',
        },
        code: '+43',
        emoji: '🇦🇹',
        value: 'AT',
    },
    {
        label: {
            english: 'Azerbaijan',
            french: 'Azerbaïdjan',
            german: 'Aserbaidschan',
            dutch: 'Azerbeidzjan',
        },
        code: '+994',
        emoji: '🇦🇿',
        value: 'AZ',
    },
    {
        label: {
            english: 'Bahamas',
            french: 'Bahamas',
            german: 'Bahamas',
            dutch: "Bahama's",
        },
        code: '+1242',
        emoji: '🇧🇸',
        value: 'BS',
    },
    {
        label: {
            english: 'Bahrain',
            french: 'Bahreïn',
            german: 'Bahrain',
            dutch: 'Bahrein',
        },
        code: '+973',
        emoji: '🇧🇭',
        value: 'BH',
    },
    {
        label: {
            english: 'Bangladesh',
            french: 'Bangladesh',
            german: 'Bangladesch',
            dutch: 'Bangladesh',
        },
        code: '+880',
        emoji: '🇧🇩',
        value: 'BD',
    },
    {
        label: {
            english: 'Barbados',
            french: 'Barbade',
            german: 'Barbados',
            dutch: 'Barbados',
        },
        code: '+1246',
        emoji: '🇧🇧',
        value: 'BB',
    },
    {
        label: {
            english: 'Belarus',
            french: 'Biélorussie',
            german: 'Weißrussland',
            dutch: 'Wit-Rusland',
        },
        code: '+375',
        emoji: '🇧🇾',
        value: 'BY',
    },
    {
        label: {
            english: 'Belgium',
            french: 'Belgique',
            german: 'Belgien',
            dutch: 'België',
        },
        code: '+32',
        emoji: '🇧🇪',
        value: 'BE',
    },
    {
        label: {
            english: 'Belize',
            french: 'Belize',
            german: 'Belize',
            dutch: 'Belize',
        },
        code: '+501',
        emoji: '🇧🇿',
        value: 'BZ',
    },
    {
        label: {
            english: 'Benin',
            french: 'Bénin',
            german: 'Benin',
            dutch: 'Benin',
        },
        code: '+229',
        emoji: '🇧🇯',
        value: 'BJ',
    },
    {
        label: {
            english: 'Bermuda',
            french: 'Bermudes',
            german: 'Bermuda',
            dutch: 'Bermuda',
        },
        code: '+1441',
        emoji: '🇧🇲',
        value: 'BM',
    },
    {
        label: {
            english: 'Bhutan',
            french: 'Bhoutan',
            german: 'Bhutan',
            dutch: 'Bhutan',
        },
        code: '+975',
        emoji: '🇧🇹',
        value: 'BT',
    },
    {
        label: {
            english: 'Bolivia, Plurinational State of',
            french: 'Bolivie',
            german: 'Bolivien',
            dutch: 'Bolivië',
        },
        code: '+591',
        emoji: '🇧🇴',
        value: 'BO',
    },
    {
        label: {
            english: 'Bosnia and Herzegovina',
            french: 'Bosnie-Herzégovine',
            german: 'Bosnien und Herzegowina',
            dutch: 'Bosnië en Herzegovina',
        },
        code: '+387',
        emoji: '🇧🇦',
        value: 'BA',
    },
    {
        label: {
            english: 'Botswana',
            french: 'Botswana',
            german: 'Botswana',
            dutch: 'Botswana',
        },
        code: '+267',
        emoji: '🇧🇼',
        value: 'BW',
    },
    {
        label: {
            english: 'Brazil',
            french: 'Brésil',
            german: 'Brasilien',
            dutch: 'Brazilië',
        },
        code: '+55',
        emoji: '🇧🇷',
        value: 'BR',
    },
    {
        label: {
            english: 'British Indian Ocean Territory',
            french: "Territoire britannique de l'océan indien",
            german: 'Britisches Territorium im Indischen Ozean',
            dutch: 'Britisch-Indisch-Oceanisch Territorium',
        },
        code: '+246',
        emoji: '🇮🇴',
        value: 'IO',
    },
    {
        label: {
            english: 'Brunei Darussalam',
            french: 'Brunei',
            german: 'Brunei Darussalam',
            dutch: 'Brunei',
        },
        code: '+673',
        emoji: '🇧🇳',
        value: 'BN',
    },
    {
        label: {
            english: 'Bulgaria',
            french: 'Bulgarie',
            german: 'Bulgarien',
            dutch: 'Bulgarije',
        },
        code: '+359',
        emoji: '🇧🇬',
        value: 'BG',
    },
    {
        label: {
            english: 'Burkina Faso',
            french: 'Burkina Faso',
            german: 'Burkina Faso',
            dutch: 'Burkina Faso',
        },
        code: '+226',
        emoji: '🇧🇫',
        value: 'BF',
    },
    {
        label: {
            english: 'Burundi',
            french: 'Burundi',
            german: 'Burundi',
            dutch: 'Burundi',
        },
        code: '+257',
        emoji: '🇧🇮',
        value: 'BI',
    },
    {
        label: {
            english: 'Cambodia',
            french: 'Cambodge',
            german: 'Kambodscha',
            dutch: 'Cambodja',
        },
        code: '+855',
        emoji: '🇰🇭',
        value: 'KH',
    },
    {
        label: {
            english: 'Cameroon',
            french: 'Cameroun',
            german: 'Kamerun',
            dutch: 'Kameroen',
        },
        code: '+237',
        emoji: '🇨🇲',
        value: 'CM',
    },
    {
        label: {
            english: 'Canada',
            french: 'Canada',
            german: 'Kanada',
            dutch: 'Canada',
        },
        code: '+1',
        emoji: '🇨🇦',
        value: 'CA',
    },
    {
        label: {
            english: 'Cape Verde',
            french: 'Cap-Vert',
            german: 'Kap Verde',
            dutch: 'Kaapverdië',
        },
        code: '+238',
        emoji: '🇨🇻',
        value: 'CV',
    },
    {
        label: {
            english: 'Cayman Islands',
            french: 'Îles Caïmans',
            german: 'Cayman Islands',
            dutch: 'Caymaneilanden',
        },
        code: '+345',
        emoji: '🇰🇾',
        value: 'KY',
    },
    {
        label: {
            english: 'Central African Republic',
            french: 'République centrafricaine',
            german: 'Zentralafrikanische Republik',
            dutch: 'Centraal-Afrikaanse Republiek',
        },
        code: '+236',
        emoji: '🇨🇫',
        value: 'CF',
    },
    {
        label: {
            english: 'Chad',
            french: 'Tchad',
            german: 'Tschad',
            dutch: 'Tsjaad',
        },
        code: '+235',
        emoji: '🇹🇩',
        value: 'TD',
    },
    {
        label: {
            english: 'Chile',
            french: 'Chili',
            german: 'Chile',
            dutch: 'Chili',
        },
        code: '+56',
        emoji: '🇨🇱',
        value: 'CL',
    },
    {
        label: {
            english: 'China',
            french: 'Chine',
            german: 'China',
            dutch: 'China',
        },
        code: '+86',
        emoji: '🇨🇳',
        value: 'CN',
    },
    {
        label: {
            english: 'Christmas Island',
            french: 'Île Christmas',
            german: 'Weihnachtsinsel',
            dutch: 'Christmaseiland',
        },
        code: '+61',
        emoji: '🇨🇽',
        value: 'CX',
    },
    {
        label: {
            english: 'Cocos (Keeling) Islands',
            french: 'Îles Cocos (Keeling)',
            german: 'Kokosinseln',
            dutch: 'Cocoseilanden',
        },
        code: '+61',
        emoji: '🇨🇨',
        value: 'CC',
    },
    {
        label: {
            english: 'Colombia',
            french: 'Colombie',
            german: 'Kolumbien',
            dutch: 'Colombia',
        },
        code: '+57',
        emoji: '🇨🇴',
        value: 'CO',
    },
    {
        label: {
            english: 'Comoros',
            french: 'Comores',
            german: 'Komoren',
            dutch: 'Comoren',
        },
        code: '+269',
        emoji: '🇰🇲',
        value: 'KM',
    },
    {
        label: {
            english: 'Congo',
            french: 'Congo',
            german: 'Kongo',
            dutch: 'Congo',
        },
        code: '+242',
        emoji: '🇨🇬',
        value: 'CG',
    },
    {
        label: {
            english: 'Congo, The Democratic Republic of the Congo',
            french: 'République démocratique du Congo',
            german: 'Demokratische Republik Kongo',
            dutch: 'Democratische Republiek Congo',
        },
        code: '+243',
        emoji: '🇨🇩',
        value: 'CD',
    },
    {
        label: {
            english: 'Cook Islands',
            french: 'Îles Cook',
            german: 'Cookinseln',
            dutch: 'Cook-eilanden',
        },
        code: '+682',
        emoji: '🇨🇰',
        value: 'CK',
    },
    {
        label: {
            english: 'Costa Rica',
            french: 'Costa Rica',
            german: 'Costa Rica',
            dutch: 'Costa Rica',
        },
        code: '+506',
        emoji: '🇨🇷',
        value: 'CR',
    },
    {
        label: {
            english: "Cote d'Ivoire",
            french: "Côte d'Ivoire",
            german: 'Elfenbeinküste',
            dutch: 'Ivoorkust',
        },
        code: '+225',
        emoji: '🇨🇮',
        value: 'CI',
    },
    {
        label: {
            english: 'Croatia',
            french: 'Croatie',
            german: 'Kroatien',
            dutch: 'Kroatië',
        },
        code: '+385',
        emoji: '🇭🇷',
        value: 'HR',
    },
    {
        label: {
            english: 'Cuba',
            french: 'Cuba',
            german: 'Kuba',
            dutch: 'Cuba',
        },
        code: '+53',
        emoji: '🇨🇺',
        value: 'CU',
    },
    {
        label: {
            english: 'Cyprus',
            french: 'Chypre',
            german: 'Zypern',
            dutch: 'Cyprus',
        },
        code: '+357',
        emoji: '🇨🇾',
        value: 'CY',
    },
    {
        label: {
            english: 'Czech Republic',
            french: 'Tchéquie',
            german: 'Tschechien',
            dutch: 'Tsjechië',
        },
        code: '+420',
        emoji: '🇨🇿',
        value: 'CZ',
    },
    {
        label: {
            english: 'Denmark',
            french: 'Danemark',
            german: 'Dänemark',
            dutch: 'Denemarken',
        },
        code: '+45',
        emoji: '🇩🇰',
        value: 'DK',
    },
    {
        label: {
            english: 'Djibouti',
            french: 'Djibouti',
            german: 'Dschibuti',
            dutch: 'Djibouti',
        },
        code: '+253',
        emoji: '🇩🇯',
        value: 'DJ',
    },
    {
        label: {
            english: 'Dominica',
            french: 'Dominique',
            german: 'Dominica',
            dutch: 'Dominica',
        },
        code: '+1767',
        emoji: '🇩🇲',
        value: 'DM',
    },
    {
        label: {
            english: 'Dominican Republic',
            french: 'République dominicaine',
            german: 'Dominikanische Republik',
            dutch: 'Dominicaanse Republiek',
        },
        code: '+1849',
        emoji: '🇩🇴',
        value: 'DO',
    },
    {
        label: {
            english: 'Ecuador',
            french: 'Équateur',
            german: 'Ecuador',
            dutch: 'Ecuador',
        },
        code: '+593',
        emoji: '🇪🇨',
        value: 'EC',
    },
    {
        label: {
            english: 'Egypt',
            french: 'Égypte',
            german: 'Ägypten',
            dutch: 'Egypte',
        },
        code: '+20',
        emoji: '🇪🇬',
        value: 'EG',
    },
    {
        label: {
            english: 'El Salvador',
            french: 'Salvador',
            german: 'El Salvador',
            dutch: 'El Salvador',
        },
        code: '+503',
        emoji: '🇸🇻',
        value: 'SV',
    },
    {
        label: {
            english: 'Equatorial Guinea',
            french: 'Guinée équatoriale',
            german: 'Äquatorialguinea',
            dutch: 'Equatoriaal-Guinea',
        },
        code: '+240',
        emoji: '🇬🇶',
        value: 'GQ',
    },
    {
        label: {
            english: 'Eritrea',
            french: 'Érythrée',
            german: 'Eritrea',
            dutch: 'Eritrea',
        },
        code: '+291',
        emoji: '🇪🇷',
        value: 'ER',
    },
    {
        label: {
            english: 'Estonia',
            french: 'Estonie',
            german: 'Estland',
            dutch: 'Estland',
        },
        code: '+372',
        emoji: '🇪🇪',
        value: 'EE',
    },
    {
        label: {
            english: 'Ethiopia',
            french: 'Éthiopie',
            german: 'Äthiopien',
            dutch: 'Ethiopië',
        },
        code: '+251',
        emoji: '🇪🇹',
        value: 'ET',
    },
    {
        label: {
            english: 'Falkland Islands (Malvinas)',
            french: 'Îles Malouines',
            german: 'Falklandinseln',
            dutch: 'Falklandeilanden',
        },
        code: '+500',
        emoji: '🇫🇰',
        value: 'FK',
    },
    {
        label: {
            english: 'Faroe Islands',
            french: 'Îles Féroé',
            german: 'Färöer',
            dutch: 'Faeröer',
        },
        code: '+298',
        emoji: '🇫🇴',
        value: 'FO',
    },
    {
        label: {
            english: 'Fiji',
            french: 'Fidji',
            german: 'Fidschi',
            dutch: 'Fiji',
        },
        code: '+679',
        emoji: '🇫🇯',
        value: 'FJ',
    },
    {
        label: {
            english: 'Finland',
            french: 'Finlande',
            german: 'Finnland',
            dutch: 'Finland',
        },
        code: '+358',
        emoji: '🇫🇮',
        value: 'FI',
    },
    {
        label: {
            english: 'France',
            french: 'France',
            german: 'Frankreich',
            dutch: 'Frankrijk',
        },
        code: '+33',
        emoji: '🇫🇷',
        value: 'FR',
    },
    {
        label: {
            english: 'French Guiana',
            french: 'Guyane française',
            german: 'Französisch-Guayana',
            dutch: 'Frans-Guyana',
        },
        code: '+594',
        emoji: '🇬🇫',
        value: 'GF',
    },
    {
        label: {
            english: 'French Polynesia',
            french: 'Polynésie française',
            german: 'Französisch-Polynesien',
            dutch: 'Frans-Polynesië',
        },
        code: '+689',
        emoji: '🇵🇫',
        value: 'PF',
    },
    {
        label: {
            english: 'Gabon',
            french: 'Gabon',
            german: 'Gabun',
            dutch: 'Gabon',
        },
        code: '+241',
        emoji: '🇬🇦',
        value: 'GA',
    },
    {
        label: {
            english: 'Gambia',
            french: 'Gambie',
            german: 'Gambia',
            dutch: 'Gambia',
        },
        code: '+220',
        emoji: '🇬🇲',
        value: 'GM',
    },
    {
        label: {
            english: 'Georgia',
            french: 'Géorgie',
            german: 'Georgien',
            dutch: 'Georgië',
        },
        code: '+995',
        emoji: '🇬🇪',
        value: 'GE',
    },
    {
        label: {
            english: 'Germany',
            french: 'Allemagne',
            german: 'Deutschland',
            dutch: 'Duitsland',
        },
        code: '+49',
        emoji: '🇩🇪',
        value: 'DE',
    },
    {
        label: {
            english: 'Ghana',
            french: 'Ghana',
            german: 'Ghana',
            dutch: 'Ghana',
        },
        code: '+233',
        emoji: '🇬🇭',
        value: 'GH',
    },
    {
        label: {
            english: 'Gibraltar',
            french: 'Gibraltar',
            german: 'Gibraltar',
            dutch: 'Gibraltar',
        },
        code: '+350',
        emoji: '🇬🇮',
        value: 'GI',
    },
    {
        label: {
            english: 'Greece',
            french: 'Grèce',
            german: 'Griechenland',
            dutch: 'Griekenland',
        },
        code: '+30',
        emoji: '🇬🇷',
        value: 'GR',
    },
    {
        label: {
            english: 'Greenland',
            french: 'Groenland',
            german: 'Grönland',
            dutch: 'Groenland',
        },
        code: '+299',
        emoji: '🇬🇱',
        value: 'GL',
    },
    {
        label: {
            english: 'Grenada',
            french: 'Grenade',
            german: 'Grenada',
            dutch: 'Grenada',
        },
        code: '+1473',
        emoji: '🇬🇩',
        value: 'GD',
    },
    {
        label: {
            english: 'Guadeloupe',
            french: 'Guadeloupe',
            german: 'Guadeloupe',
            dutch: 'Guadeloupe',
        },
        code: '+590',
        emoji: '🇬🇵',
        value: 'GP',
    },
    {
        label: {
            english: 'Guam',
            french: 'Guam',
            german: 'Guam',
            dutch: 'Guam',
        },
        code: '+1671',
        emoji: '🇬🇺',
        value: 'GU',
    },
    {
        label: {
            english: 'Guatemala',
            french: 'Guatemala',
            german: 'Guatemala',
            dutch: 'Guatemala',
        },
        code: '+502',
        emoji: '🇬🇹',
        value: 'GT',
    },
    {
        label: {
            english: 'Guernsey',
            french: 'Guernesey',
            german: 'Guernsey',
            dutch: 'Guernsey',
        },
        code: '+44',
        emoji: '🇬🇬',
        value: 'GG',
    },
    {
        label: {
            english: 'Guinea',
            french: 'Guinée',
            german: 'Guinea',
            dutch: 'Guinee',
        },
        code: '+224',
        emoji: '🇬🇳',
        value: 'GN',
    },
    {
        label: {
            english: 'Guinea-Bissau',
            french: 'Guinée-Bissau',
            german: 'Guinea-Bissau',
            dutch: 'Guinee-Bissau',
        },
        code: '+245',
        emoji: '🇬🇼',
        value: 'GW',
    },
    {
        label: {
            english: 'Guyana',
            french: 'Guyana',
            german: 'Guyana',
            dutch: 'Guyana',
        },
        code: '+595',
        emoji: '🇬🇾',
        value: 'GY',
    },
    {
        label: {
            english: 'Haiti',
            french: 'Haïti',
            german: 'Haiti',
            dutch: 'Haïti',
        },
        code: '+509',
        emoji: '🇭🇹',
        value: 'HT',
    },
    {
        label: {
            english: 'Holy See (Vatican City State)',
            french: 'Vatican',
            german: 'Vatikan',
            dutch: 'Vaticaan',
        },
        code: '+379',
        emoji: '🇻🇦',
        value: 'VA',
    },
    {
        label: {
            english: 'Honduras',
            french: 'Honduras',
            german: 'Honduras',
            dutch: 'Honduras',
        },
        code: '+504',
        emoji: '🇭🇳',
        value: 'HN',
    },
    {
        label: {
            english: 'Hong Kong',
            french: 'Hong Kong',
            german: 'Hong Kong',
            dutch: 'Hong Kong',
        },
        code: '+852',
        emoji: '🇭🇰',
        value: 'HK',
    },
    {
        label: {
            english: 'Hungary',
            french: 'Hongrie',
            german: 'Ungarn',
            dutch: 'Hongarije',
        },
        code: '+36',
        emoji: '🇭🇺',
        value: 'HU',
    },
    {
        label: {
            english: 'Iceland',
            french: 'Islande',
            german: 'Island',
            dutch: 'IJsland',
        },
        code: '+354',
        emoji: '🇮🇸',
        value: 'IS',
    },
    {
        label: {
            english: 'India',
            french: 'Inde',
            german: 'Indien',
            dutch: 'India',
        },
        code: '+91',
        emoji: '🇮🇳',
        value: 'IN',
    },
    {
        label: {
            english: 'Indonesia',
            french: 'Indonésie',
            german: 'Indonesien',
            dutch: 'Indonesië',
        },
        code: '+62',
        emoji: '🇮🇩',
        value: 'ID',
    },
    {
        label: { english: 'Iran, Islamic Republic of Persian Gulf' },
        code: '+98',
        emoji: '🇮🇷',
        value: 'IR',
    },
    {
        label: { english: 'Iraq', french: 'Irak', german: 'Irak', dutch: 'Irak' },
        code: '+964',
        emoji: '🇮🇷',
        value: 'IQ',
    },
    {
        label: {
            english: 'Ireland',
            french: 'Irlande',
            german: 'Irland',
            dutch: 'Ierland',
        },
        code: '+353',
        emoji: '🇮🇪',
        value: 'IE',
    },
    {
        label: {
            english: 'Isle of Man',
            french: 'Île de Man',
            german: 'Insel Man',
            dutch: 'Man',
        },
        code: '+44',
        emoji: '🇮🇲',
        value: 'IM',
    },
    {
        label: {
            english: 'Israel',
            french: 'Israël',
            german: 'Israel',
            dutch: 'Israël',
        },
        code: '+972',
        emoji: '🇮🇱',
        value: 'IL',
    },
    {
        label: {
            english: 'Italy',
            french: 'Italie',
            german: 'Italien',
            dutch: 'Italië',
        },
        code: '+39',
        emoji: '🇮🇹',
        value: 'IT',
    },
    {
        label: {
            english: 'Jamaica',
            french: 'Jamaïque',
            german: 'Jamaika',
            dutch: 'Jamaica',
        },
        code: '+1876',
        emoji: '🇯🇲',
        value: 'JM',
    },
    {
        label: {
            english: 'Japan',
            french: 'Japon',
            german: 'Japan',
            dutch: 'Japan',
        },
        code: '+81',
        emoji: '🇯🇵',
        value: 'JP',
    },
    {
        label: {
            english: 'Jersey',
            french: 'Jersey',
            german: 'Jersey',
            dutch: 'Jersey',
        },
        code: '+44',
        emoji: '🇯🇪',
        value: 'JE',
    },
    {
        label: {
            english: 'Jordan',
            french: 'Jordanie',
            german: 'Jordanien',
            dutch: 'Jordanië',
        },
        code: '+962',
        emoji: '🇯🇴',
        value: 'JO',
    },
    {
        label: {
            english: 'Kazakhstan',
            french: 'Kazakhstan',
            german: 'Kasachstan',
            dutch: 'Kazachstan',
        },
        code: '+77',
        emoji: '🇰🇿',
        value: 'KZ',
    },
    {
        label: {
            english: 'Kenya',
            french: 'Kenya',
            german: 'Kenia',
            dutch: 'Kenia',
        },
        code: '+254',
        emoji: '🇰🇪',
        value: 'KE',
    },
    {
        label: {
            english: 'Kiribati',
            french: 'Kiribati',
            german: 'Kiribati',
            dutch: 'Kiribati',
        },
        code: '+686',
        emoji: '🇰🇮',
        value: 'KI',
    },
    {
        label: {
            english: "Korea, Democratic People's Republic of Korea",
            french: 'Corée du Nord',
            german: 'Nordkorea',
            dutch: 'Noord-Korea',
        },
        code: '+850',
        emoji: '🇰🇵',
        value: 'KP',
    },
    {
        label: {
            english: 'Korea, Republic of South Korea',
            french: 'Corée du Sud',
            german: 'Südkorea',
            dutch: 'Zuid-Korea',
        },
        code: '+82',
        emoji: '🇰🇷',
        value: 'KR',
    },
    {
        label: {
            english: 'Kuwait',
            french: 'Koweït',
            german: 'Kuwait',
            dutch: 'Koeweit',
        },
        code: '+965',
        emoji: '🇰🇼',
        value: 'KW',
    },
    {
        label: {
            english: 'Kyrgyzstan',
            french: 'Kirghizistan',
            german: 'Kirgisistan',
            dutch: 'Kirgizië',
        },
        code: '+996',
        emoji: '🇰🇬',
        value: 'KG',
    },
    {
        label: { english: 'Laos', french: 'Laos', german: 'Laos', dutch: 'Laos' },
        code: '+856',
        emoji: '🇱🇦',
        value: 'LA',
    },
    {
        label: {
            english: 'Latvia',
            french: 'Lettonie',
            german: 'Lettland',
            dutch: 'Letland',
        },
        code: '+371',
        emoji: '🇱🇻',
        value: 'LV',
    },
    {
        label: {
            english: 'Lebanon',
            french: 'Liban',
            german: 'Libanon',
            dutch: 'Libanon',
        },
        code: '+961',
        emoji: '🇱🇧',
        value: 'LB',
    },
    {
        label: {
            english: 'Lesotho',
            french: 'Lesotho',
            german: 'Lesotho',
            dutch: 'Lesotho',
        },
        code: '+266',
        emoji: '🇱🇸',
        value: 'LS',
    },
    {
        label: {
            english: 'Liberia',
            french: 'Liberia',
            german: 'Liberia',
            dutch: 'Liberia',
        },
        code: '+231',
        emoji: '🇱🇷',
        value: 'LR',
    },
    {
        label: {
            english: 'Libyan Arab Jamahiriya',
            french: 'Libye',
            german: 'Libyen',
            dutch: 'Libië',
        },
        code: '+218',
        emoji: '🇱🇾',
        value: 'LY',
    },
    {
        label: {
            english: 'Liechtenstein',
            french: 'Liechtenstein',
            german: 'Liechtenstein',
            dutch: 'Liechtenstein',
        },
        code: '+423',
        emoji: '🇱🇮',
        value: 'LI',
    },
    {
        label: {
            english: 'Lithuania',
            french: 'Lituanie',
            german: 'Litauen',
            dutch: 'Litouwen',
        },
        code: '+370',
        emoji: '🇱🇹',
        value: 'LT',
    },
    {
        label: {
            english: 'Luxembourg',
            french: 'Luxembourg',
            german: 'Luxemburg',
            dutch: 'Luxemburg',
        },
        code: '+352',
        emoji: '🇱🇺',
        value: 'LU',
    },
    {
        label: {
            english: 'Macao',
            french: 'Macau',
            german: 'Macau',
            dutch: 'Macau',
        },
        code: '+853',
        emoji: '🇲🇴',
        value: 'MO',
    },
    {
        label: {
            english: 'Macedonia',
            french: 'Macédoine',
            german: 'Mazedonien',
            dutch: 'Macedonië',
        },
        code: '+389',
        emoji: '🇲🇰',
        value: 'MK',
    },
    {
        label: {
            english: 'Madagascar',
            french: 'Madagascar',
            german: 'Madagaskar',
            dutch: 'Madagaskar',
        },
        code: '+261',
        emoji: '🇲🇬',
        value: 'MG',
    },
    {
        label: {
            english: 'Malawi',
            french: 'Malawi',
            german: 'Malawi',
            dutch: 'Malawi',
        },
        code: '+265',
        emoji: '🇲🇼',
        value: 'MW',
    },
    {
        label: {
            english: 'Malaysia',
            french: 'Malaisie',
            german: 'Malaysia',
            dutch: 'Maleisië',
        },
        code: '+60',
        emoji: '🇲🇾',
        value: 'MY',
    },
    {
        label: {
            english: 'Maldives',
            french: 'Maldives',
            german: 'Malediven',
            dutch: 'Maldiven',
        },
        code: '+960',
        emoji: '🇲🇻',
        value: 'MV',
    },
    {
        label: { english: 'Mali', french: 'Mali', german: 'Mali', dutch: 'Mali' },
        code: '+223',
        emoji: '🇲🇱',
        value: 'ML',
    },
    {
        label: {
            english: 'Malta',
            french: 'Malte',
            german: 'Malta',
            dutch: 'Malta',
        },
        code: '+356',
        emoji: '🇲🇹',
        value: 'MT',
    },
    {
        label: {
            english: 'Marshall Islands',
            french: 'Îles Marshall',
            german: 'Marshallinseln',
            dutch: 'Marshalleilanden',
        },
        code: '+692',
        emoji: '🇲🇭',
        value: 'MH',
    },
    {
        label: {
            english: 'Martinique',
            french: 'Martinique',
            german: 'Martinique',
            dutch: 'Martinique',
        },
        code: '+596',
        emoji: '🇲🇶',
        value: 'MQ',
    },
    {
        label: {
            english: 'Mauritania',
            french: 'Mauritanie',
            german: 'Mauretanien',
            dutch: 'Mauritanië',
        },
        code: '+222',
        emoji: '🇲🇷',
        value: 'MR',
    },
    {
        label: {
            english: 'Mauritius',
            french: 'Maurice',
            german: 'Mauritius',
            dutch: 'Mauritius',
        },
        code: '+230',
        emoji: '🇲🇺',
        value: 'MU',
    },
    {
        label: {
            english: 'Mayotte',
            french: 'Mayotte',
            german: 'Mayotte',
            dutch: 'Mayotte',
        },
        code: '+262',
        emoji: '🇾🇹',
        value: 'YT',
    },
    {
        label: {
            english: 'Mexico',
            french: 'Mexique',
            german: 'Mexiko',
            dutch: 'Mexico',
        },
        code: '+52',
        emoji: '🇲🇽',
        value: 'MX',
    },
    {
        label: {
            english: 'Micronesia, Federated States of Micronesia',
            french: 'Micronésie',
            german: 'Mikronesien',
            dutch: 'Micronesie',
        },
        code: '+691',
        emoji: '🇫🇲',
        value: 'FM',
    },
    {
        label: {
            english: 'Moldova',
            french: 'Moldavie',
            german: 'Moldawien',
            dutch: 'Moldavië',
        },
        code: '+373',
        emoji: '🇲🇩',
        value: 'MD',
    },
    {
        label: {
            english: 'Monaco',
            french: 'Monaco',
            german: 'Monaco',
            dutch: 'Monaco',
        },
        code: '+377',
        emoji: '🇲🇨',
        value: 'MC',
    },
    {
        label: {
            english: 'Mongolia',
            french: 'Mongolie',
            german: 'Mongolei',
            dutch: 'Mongolië',
        },
        code: '+976',
        emoji: '🇲🇳',
        value: 'MN',
    },
    {
        label: {
            english: 'Montenegro',
            french: 'Monténégro',
            german: 'Montenegro',
            dutch: 'Montenegro',
        },
        code: '+382',
        emoji: '🇲🇪',
        value: 'ME',
    },
    {
        label: {
            english: 'Montserrat',
            french: 'Montserrat',
            german: 'Montserrat',
            dutch: 'Montserrat',
        },
        code: '+1664',
        emoji: '🇲🇸',
        value: 'MS',
    },
    {
        label: {
            english: 'Morocco',
            french: 'Maroc',
            german: 'Marokko',
            dutch: 'Marokko',
        },
        code: '+212',
        emoji: '🇲🇦',
        value: 'MA',
    },
    {
        label: {
            english: 'Mozambique',
            french: 'Mozambique',
            german: 'Mosambik',
            dutch: 'Mozambique',
        },
        code: '+258',
        emoji: '🇲🇿',
        value: 'MZ',
    },
    {
        label: {
            english: 'Myanmar',
            french: 'Myanmar',
            german: 'Myanmar',
            dutch: 'Myanmar',
        },
        code: '+95',
        emoji: '🇲🇲',
        value: 'MM',
    },
    {
        label: {
            english: 'Namibia',
            french: 'Namibie',
            german: 'Namibia',
            dutch: 'Namibië',
        },
        emoji: '🇳🇦',
        code: '+264',
        value: 'NA',
    },
    {
        label: {
            english: 'Nauru',
            french: 'Nauru',
            german: 'Nauru',
            dutch: 'Nauru',
        },
        code: '+674',
        emoji: '🇳🇷',
        value: 'NR',
    },
    {
        label: {
            english: 'Nepal',
            french: 'Népal',
            german: 'Nepal',
            dutch: 'Nepal',
        },
        code: '+977',
        emoji: '🇳🇵',
        value: 'NP',
    },
    {
        label: {
            english: 'Netherlands',
            french: 'Pays-Bas',
            german: 'Niederlande',
            dutch: 'Nederland',
        },
        code: '+31',
        emoji: '🇳🇱',
        value: 'NL',
    },
    {
        label: {
            english: 'Netherlands Antilles',
            french: 'Antilles néerlandaises',
            german: 'Niederländische Antillen',
            dutch: 'Nederlandse Antillen',
        },
        code: '+599',
        emoji: '🇧🇶',
        value: 'AN',
    },
    {
        label: {
            english: 'New Caledonia',
            french: 'Nouvelle-Calédonie',
            german: 'Neukaledonien',
            dutch: 'Nieuw-Caledonië',
        },
        code: '+687',
        emoji: '🇳🇨',
        value: 'NC',
    },
    {
        label: {
            english: 'New Zealand',
            french: 'Nouvelle-Zélande',
            german: 'Neuseeland',
            dutch: 'Nieuw-Zeeland',
        },
        code: '+64',
        emoji: '🇳🇿',
        value: 'NZ',
    },
    {
        label: {
            english: 'Nicaragua',
            french: 'Nicaragua',
            german: 'Nicaragua',
            dutch: 'Nicaragua',
        },
        code: '+505',
        emoji: '🇳🇮',
        value: 'NI',
    },
    {
        label: {
            english: 'Niger',
            french: 'Niger',
            german: 'Niger',
            dutch: 'Niger',
        },
        code: '+227',
        emoji: '🇳🇪',
        value: 'NE',
    },
    {
        label: {
            english: 'Nigeria',
            french: 'Nigéria',
            german: 'Nigeria',
            dutch: 'Nigeria',
        },
        code: '+234',
        emoji: '🇳🇬',
        value: 'NG',
    },
    {
        label: { english: 'Niue', french: 'Niue', german: 'Niue', dutch: 'Niue' },
        code: '+683',
        emoji: '🇳🇺',
        value: 'NU',
    },
    {
        label: {
            english: 'Norfolk Island',
            french: 'Île Norfolk',
            german: 'Norfolkinsel',
            dutch: 'Norfolkeiland',
        },
        code: '+672',
        emoji: '🇳🇫',
        value: 'NF',
    },
    {
        label: {
            english: 'Northern Mariana Islands',
            french: 'Îles Mariannes du Nord',
            german: 'Nördliche Marianen',
            dutch: 'Noordelijke Marianen',
        },
        code: '+1670',
        emoji: '🇲🇵',
        value: 'MP',
    },
    {
        label: {
            english: 'Norway',
            french: 'Norvège',
            german: 'Norwegen',
            dutch: 'Noorwegen',
        },
        code: '+47',
        emoji: '🇳🇴',
        value: 'NO',
    },
    {
        label: { english: 'Oman', french: 'Oman', german: 'Oman', dutch: 'Oman' },
        code: '+968',
        emoji: '🇴🇲',
        value: 'OM',
    },
    {
        label: {
            english: 'Pakistan',
            french: 'Pakistan',
            german: 'Pakistan',
            dutch: 'Pakistan',
        },
        code: '+92',
        emoji: '🇵🇰',
        value: 'PK',
    },
    {
        label: {
            english: 'Palau',
            french: 'Palaos',
            german: 'Palau',
            dutch: 'Palau',
        },
        code: '+680',
        emoji: '🇵🇼',
        value: 'PW',
    },
    {
        label: {
            english: 'Palestinian Territory, Occupied',
            french: 'Territoire palestinien',
            german: 'Palästinensische Autonomiegebiete',
            dutch: 'Palestijns-gewest',
        },
        code: '+970',
        emoji: '🇵🇸',
        value: 'PS',
    },
    {
        label: {
            english: 'Panama',
            french: 'Panama',
            german: 'Panama',
            dutch: 'Panama',
        },
        code: '+507',
        emoji: '🇵🇦',
        value: 'PA',
    },
    {
        label: {
            english: 'Papua New Guinea',
            french: 'Papouasie-Nouvelle-Guinée',
            german: 'Papua-Neuguinea',
            dutch: 'Papoea-Nieuw-Guinea',
        },
        code: '+675',
        emoji: '🇵🇬',
        value: 'PG',
    },
    {
        label: {
            english: 'Paraguay',
            french: 'Paraguay',
            german: 'Paraguay',
            dutch: 'Paraguay',
        },
        code: '+595',
        emoji: '🇵🇾',
        value: 'PY',
    },
    {
        label: { english: 'Peru', french: 'Pérou', german: 'Peru', dutch: 'Peru' },
        code: '+51',
        emoji: '🇵🇪',
        value: 'PE',
    },
    {
        label: {
            english: 'Philippines',
            french: 'Philippines',
            german: 'Philippinen',
            dutch: 'Filipijnen',
        },
        code: '+63',
        emoji: '🇵🇭',
        value: 'PH',
    },
    {
        label: {
            english: 'Pitcairn',
            french: 'Pitcairn',
            german: 'Pitcairn',
            dutch: 'Pitcairn',
        },
        code: '+872',
        emoji: '🇵🇳',
        value: 'PN',
    },
    {
        label: {
            english: 'Poland',
            french: 'Pologne',
            german: 'Polen',
            dutch: 'Polen',
        },
        code: '+48',
        emoji: '🇵🇱',
        value: 'PL',
    },
    {
        label: {
            english: 'Portugal',
            french: 'Portugal',
            german: 'Portugal',
            dutch: 'Portugal',
        },
        code: '+351',
        emoji: '🇵🇹',
        value: 'PT',
    },
    {
        label: {
            english: 'Puerto Rico',
            french: 'Porto Rico',
            german: 'Puerto Rico',
            dutch: 'Puerto Rico',
        },
        code: '+1939',
        emoji: '🇵🇷',
        value: 'PR',
    },
    {
        label: {
            english: 'Qatar',
            french: 'Qatar',
            german: 'Katar',
            dutch: 'Qatar',
        },
        code: '+974',
        emoji: '🇶🇦',
        value: 'QA',
    },
    {
        label: {
            english: 'Romania',
            french: 'Roumanie',
            german: 'Rumänien',
            dutch: 'Roemenië',
        },
        code: '+40',
        emoji: '🇷🇴',
        value: 'RO',
    },
    {
        label: {
            english: 'Russia',
            french: 'Russie',
            german: 'Russland',
            dutch: 'Rusland',
        },
        code: '+7',
        emoji: '🇷🇺',
        value: 'RU',
    },
    {
        label: {
            english: 'Rwanda',
            french: 'Rwanda',
            german: 'Ruanda',
            dutch: 'Rwanda',
        },
        code: '+250',
        emoji: '🇷🇼',
        value: 'RW',
    },
    {
        label: {
            english: 'Reunion',
            french: 'Réunion',
            german: 'Réunion',
            dutch: 'Réunion',
        },
        code: '+262',
        emoji: '🇷🇪',
        value: 'RE',
    },
    {
        label: {
            english: 'Saint Barthelemy',
            french: 'Saint-Barthélemy',
            german: 'Saint-Barthélemy',
            dutch: 'Saint-Barthélemy',
        },
        code: '+590',
        emoji: '🇧🇱',
        value: 'BL',
    },
    {
        label: {
            english: 'Saint Helena, Ascension and Tristan Da Cunha',
            french: 'Sainte-Hélène, Ascension et Tristan da Cunha',
            german: 'Sankt-Helena, Ascension und Tristan da Cunha',
            dutch: 'Sint-Helena, Ascension en Tristan da Cunha',
        },
        code: '+290',
        emoji: '🇸🇭',
        value: 'SH',
    },
    {
        label: {
            english: 'Saint Kitts and Nevis',
            french: 'Saint-Kitts-et-Nevis',
            german: 'St. Kitts und Nevis',
            dutch: 'Saint Kitts en Nevis',
        },
        code: '+1869',
        emoji: '🇰🇳',
        value: 'KN',
    },
    {
        label: {
            english: 'Saint Lucia',
            french: 'Sainte-Lucie',
            german: 'St. Lucia',
            dutch: 'Saint Lucia',
        },
        code: '+1758',
        emoji: '🇱🇨',
        value: 'LC',
    },
    {
        label: {
            english: 'Saint Martin',
            french: 'Saint-Martin',
            german: 'Saint-Martin',
            dutch: 'Saint-Martin',
        },
        code: '+590',
        emoji: '🇲🇫',
        value: 'MF',
    },
    {
        label: {
            english: 'Saint Pierre and Miquelon',
            french: 'Saint-Pierre-et-Miquelon',
            german: 'Saint-Pierre-et-Miquelon',
            dutch: 'Saint-Pierre-et-Miquelon',
        },
        code: '+508',
        emoji: '🇵🇲',
        value: 'PM',
    },
    {
        label: {
            english: 'Saint Vincent and the Grenadines',
            french: 'Saint-Vincent-et-les-Grenadines',
            german: 'St. Vincent und die Grenadinen',
            dutch: 'Saint Vincent en de Grenadines',
        },
        code: '+1784',
        emoji: '🇻🇨',
        value: 'VC',
    },
    {
        label: {
            english: 'Samoa',
            french: 'Samoa',
            german: 'Samoa',
            dutch: 'Samoa',
        },
        code: '+685',
        emoji: '🇼🇸',
        value: 'WS',
    },
    {
        label: {
            english: 'San Marino',
            french: 'Saint-Marin',
            german: 'San Marino',
            dutch: 'San Marino',
        },
        code: '+378',
        emoji: '🇸🇲',
        value: 'SM',
    },
    {
        label: {
            english: 'Sao Tome and Principe',
            french: 'Sao Tomé-et-Principe',
            german: 'São Tomé und Príncipe',
            dutch: 'Sao Tomé en Principe',
        },
        code: '+239',
        emoji: '🇸🇹',
        value: 'ST',
    },
    {
        label: {
            english: 'Saudi Arabia',
            french: 'Arabie Saoudite',
            german: 'Saudi-Arabien',
            dutch: 'Saoedi-Arabië',
        },
        code: '+966',
        emoji: '🇸🇦',
        value: 'SA',
    },
    {
        label: {
            english: 'Senegal',
            french: 'Sénégal',
            german: 'Senegal',
            dutch: 'Senegal',
        },
        code: '+221',
        emoji: '🇸🇳',
        value: 'SN',
    },
    {
        label: {
            english: 'Serbia',
            french: 'Serbie',
            german: 'Serbien',
            dutch: 'Servië',
        },
        code: '+381',
        emoji: '🇷🇸',
        value: 'RS',
    },
    {
        label: {
            english: 'Seychelles',
            french: 'Seychelles',
            german: 'Seychellen',
            dutch: 'Seychellen',
        },
        code: '+248',
        emoji: '🇸🇨',
        value: 'SC',
    },
    {
        label: {
            english: 'Sierra Leone',
            french: 'Sierra Leone',
            german: 'Sierra Leone',
            dutch: 'Sierra Leone',
        },
        code: '+232',
        emoji: '🇸🇱',
        value: 'SL',
    },
    {
        label: {
            english: 'Singapore',
            french: 'Singapour',
            german: 'Singapur',
            dutch: 'Singapore',
        },
        code: '+65',
        emoji: '🇸🇬',
        value: 'SG',
    },
    {
        label: {
            english: 'Slovakia',
            french: 'Slovaquie',
            german: 'Slowakei',
            dutch: 'Slowakije',
        },
        code: '+421',
        emoji: '🇸🇰',
        value: 'SK',
    },
    {
        label: {
            english: 'Slovenia',
            french: 'Slovénie',
            german: 'Slowenien',
            dutch: 'Slovenië',
        },
        code: '+386',
        emoji: '🇸🇮',
        value: 'SI',
    },
    {
        label: {
            english: 'Solomon Islands',
            french: 'Îles Salomon',
            german: 'Salomonen',
            dutch: 'Salomonseilanden',
        },
        code: '+677',
        emoji: '🇸🇧',
        value: 'SB',
    },
    {
        label: {
            english: 'Somalia',
            french: 'Somalie',
            german: 'Somalia',
            dutch: 'Somalië',
        },
        code: '+252',
        emoji: '🇸🇴',
        value: 'SO',
    },
    {
        label: {
            english: 'South Africa',
            french: 'Afrique du Sud',
            german: 'Südafrika',
            dutch: 'Zuid-Afrika',
        },
        code: '+27',
        emoji: '🇿🇦',
        value: 'ZA',
    },
    {
        label: {
            english: 'South Sudan',
            french: 'Soudan du Sud',
            german: 'Südsudan',
            dutch: 'Zuid-Soedan',
        },
        code: '+211',
        emoji: '🇸🇸',
        value: 'SS',
    },
    {
        label: {
            english: 'South Georgia and the South Sandwich Islands',
            french: 'Géorgie du Sud et les Îles Sandwich du Sud',
            german: 'Südgeorgien und die Südlichen Sandwichinseln',
            dutch: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
        },
        code: '+500',
        emoji: '🇬🇸',
        value: 'GS',
    },
    {
        label: {
            english: 'Spain',
            french: 'Espagne',
            german: 'Spanien',
            dutch: 'Spanje',
        },
        code: '+34',
        emoji: '🇪🇸',
        value: 'ES',
    },
    {
        label: {
            english: 'Sri Lanka',
            french: 'Sri Lanka',
            german: 'Sri Lanka',
            dutch: 'Sri Lanka',
        },
        code: '+94',
        emoji: '🇱🇰',
        value: 'LK',
    },
    {
        label: {
            english: 'Sudan',
            french: 'Soudan',
            german: 'Sudan',
            dutch: 'Soedan',
        },
        code: '+249',
        emoji: '🇸🇩',
        value: 'SD',
    },
    {
        label: {
            english: 'Suriname',
            french: 'Suriname',
            german: 'Suriname',
            dutch: 'Suriname',
        },
        code: '+597',
        emoji: '🇸🇷',
        value: 'SR',
    },
    {
        label: {
            english: 'Svalbard and Jan Mayen',
            french: 'Svalbard et Jan Mayen',
            german: 'Svalbard und Jan Mayen',
            dutch: 'Svalbard en Jan Mayen',
        },
        code: '+47',
        emoji: '🇸🇯',
        value: 'SJ',
    },
    {
        label: {
            english: 'Swaziland',
            french: 'Swaziland',
            german: 'Swasiland',
            dutch: 'Swaziland',
        },
        code: '+268',
        emoji: '🇸🇿',
        value: 'SZ',
    },
    {
        label: {
            english: 'Sweden',
            french: 'Suède',
            german: 'Schweden',
            dutch: 'Zweden',
        },
        code: '+46',
        emoji: '🇸🇪',
        value: 'SE',
    },
    {
        label: {
            english: 'Switzerland',
            french: 'Suisse',
            german: 'Schweiz',
            dutch: 'Zwitserland',
        },
        code: '+41',
        emoji: '🇨🇭',
        value: 'CH',
    },
    {
        label: {
            english: 'Syrian Arab Republic',
            french: 'République arabe syrienne',
            german: 'Syrische Arabische Republik',
            dutch: 'Syrische Arabische Republiek',
        },
        code: '+963',
        emoji: '🇸🇾',
        value: 'SY',
    },
    {
        label: {
            english: 'Taiwan',
            french: 'Taïwan',
            german: 'Taiwan',
            dutch: 'Taiwan',
        },
        code: '+886',
        emoji: '🇹🇼',
        value: 'TW',
    },
    {
        label: {
            english: 'Tajikistan',
            french: 'Tadjikistan',
            german: 'Tadschikistan',
            dutch: 'Tadzjikistan',
        },
        code: '+992',
        emoji: '🇹🇯',
        value: 'TJ',
    },
    {
        label: {
            english: 'Tanzania, United Republic of Tanzania',
            french: 'Tanzanie',
            german: 'Tansania',
            dutch: 'Tanzania',
        },
        code: '+255',
        emoji: '🇹🇿',
        value: 'TZ',
    },
    {
        label: {
            english: 'Thailand',
            french: 'Thaïlande',
            german: 'Thailand',
            dutch: 'Thailand',
        },
        code: '+66',
        emoji: '🇹🇭',
        value: 'TH',
    },
    {
        label: {
            english: 'Timor-Leste',
            french: 'Timor-Leste',
            german: 'Timor-Leste',
            dutch: 'Timor-Leste',
        },
        code: '+670',
        emoji: '🇹🇱',
        value: 'TL',
    },
    {
        label: { english: 'Togo', french: 'Togo', german: 'Togo', dutch: 'Togo' },
        code: '+228',
        emoji: '🇹🇬',
        value: 'TG',
    },
    {
        label: {
            english: 'Tokelau',
            french: 'Tokelau',
            german: 'Tokelau',
            dutch: 'Tokelau',
        },
        code: '+690',
        emoji: '🇹🇰',
        value: 'TK',
    },
    {
        label: {
            english: 'Tonga',
            french: 'Tonga',
            german: 'Tonga',
            dutch: 'Tonga',
        },
        code: '+676',
        emoji: '🇹🇴',
        value: 'TO',
    },
    {
        label: {
            english: 'Trinidad and Tobago',
            french: 'Trinité-et-Tobago',
            german: 'Trinidad und Tobago',
            dutch: 'Trinidad en Tobago',
        },
        code: '+1868',
        emoji: '🇹🇹',
        value: 'TT',
    },
    {
        label: {
            english: 'Tunisia',
            french: 'Tunisie',
            german: 'Tunesien',
            dutch: 'Tunesië',
        },
        code: '+216',
        emoji: '🇹🇳',
        value: 'TN',
    },
    {
        label: {
            english: 'Turkey',
            french: 'Turquie',
            german: 'Türkei',
            dutch: 'Turkije',
        },
        code: '+90',
        emoji: '🇹🇷',
        value: 'TR',
    },
    {
        label: {
            english: 'Turkmenistan',
            french: 'Turkménistan',
            german: 'Turkmenistan',
            dutch: 'Turkmenistan',
        },
        code: '+993',
        emoji: '🇹🇲',
        value: 'TM',
    },
    {
        label: {
            english: 'Turks and Caicos Islands',
            french: 'Îles Turques-et-Caïques',
            german: 'Turks- und Caicosinseln',
            dutch: 'Turks- en Caicoseilanden',
        },
        code: '+1649',
        emoji: '🇹🇨',
        value: 'TC',
    },
    {
        label: {
            english: 'Tuvalu',
            french: 'Tuvalu',
            german: 'Tuvalu',
            dutch: 'Tuvalu',
        },
        code: '+688',
        emoji: '🇹🇻',
        value: 'TV',
    },
    {
        label: {
            english: 'Uganda',
            french: 'Ouganda',
            german: 'Uganda',
            dutch: 'Oeganda',
        },
        code: '+256',
        emoji: '🇺🇬',
        value: 'UG',
    },
    {
        label: {
            english: 'Ukraine',
            french: 'Ukraine',
            german: 'Ukraine',
            dutch: 'Oekraïne',
        },
        code: '+380',
        emoji: '🇺🇦',
        value: 'UA',
    },
    {
        label: {
            english: 'United Arab Emirates',
            french: 'Émirats Arabes Unis',
            german: 'Vereinigte Arabische Emirate',
            dutch: 'Verenigde Arabische Emiraten',
        },
        code: '+971',
        emoji: '🇦🇪',
        value: 'AE',
    },
    {
        label: {
            english: 'United Kingdom',
            french: 'Royaume-Uni',
            german: 'Vereinigtes Königreich',
            dutch: 'Verenigd Koninkrijk',
        },
        code: '+44',
        emoji: '🇬🇧',
        value: 'GB',
    },
    {
        label: {
            english: 'United States',
            french: 'États-Unis',
            german: 'Vereinigte Staaten',
            dutch: 'Verenigde Staten',
        },
        code: '+1',
        emoji: '🇺🇸',
        value: 'US',
    },
    {
        label: {
            english: 'Uruguay',
            french: 'Uruguay',
            german: 'Uruguay',
            dutch: 'Uruguay',
        },
        code: '+598',
        emoji: '🇺🇾',
        value: 'UY',
    },
    {
        label: {
            english: 'Uzbekistan',
            french: 'Ouzbékistan',
            german: 'Usbekistan',
            dutch: 'Oezbekistan',
        },
        code: '+998',
        emoji: '🇺🇿',
        value: 'UZ',
    },
    {
        label: {
            english: 'Vanuatu',
            french: 'Vanuatu',
            german: 'Vanuatu',
            dutch: 'Vanuatu',
        },
        code: '+678',
        emoji: '🇻🇺',
        value: 'VU',
    },
    {
        label: {
            english: 'Venezuela, Bolivarian Republic of Venezuela',
            french: 'Venezuela',
            german: 'Venezuela',
            dutch: 'Venezuela',
        },
        code: '+58',
        emoji: '🇻🇪',
        value: 'VE',
    },
    {
        label: {
            english: 'Vietnam',
            french: 'Vietnam',
            german: 'Vietnam',
            dutch: 'Vietnam',
        },
        code: '+84',
        emoji: '🇻🇳',
        value: 'VN',
    },
    {
        label: {
            english: 'Virgin Islands, British',
            french: 'Îles Vierges britanniques',
            german: 'Britische Jungferninseln',
            dutch: 'Britse Maagdeneilanden',
        },
        code: '+1284',
        emoji: '🇻🇬',
        value: 'VG',
    },
    {
        label: {
            english: 'Virgin Islands, U.S.',
            french: 'Îles Vierges américaines',
            german: 'Amerikanische Jungferninseln',
            dutch: 'Amerikaanse Maagdeneilanden',
        },
        code: '+1340',
        emoji: '🇻🇮',
        value: 'VI',
    },
    {
        label: {
            english: 'Wallis and Futuna',
            french: 'Wallis et Futuna',
            german: 'Wallis und Futuna',
            dutch: 'Wallis en Futuna',
        },
        code: '+681',
        emoji: '🇼🇫',
        value: 'WF',
    },
    {
        label: {
            english: 'Yemen',
            french: 'Yémen',
            german: 'Jemen',
            dutch: 'Jemen',
        },
        code: '+967',
        emoji: '🇾🇪',
        value: 'YE',
    },
    {
        label: {
            english: 'Zambia',
            french: 'Zambie',
            german: 'Sambia',
            dutch: 'Zambia',
        },
        code: '+260',
        emoji: '🇿🇲',
        value: 'ZM',
    },
    {
        label: {
            english: 'Zimbabwe',
            french: 'Zimbabwe',
            german: 'Simbabwe',
            dutch: 'Zimbabwe',
        },
        code: '+263',
        emoji: '🇿🇼',
        value: 'ZW',
    },
];
//# sourceMappingURL=Countries.js.map